import React from 'react'
import PropTypes from 'prop-types'
import momentLib from 'moment'

import './CountdownComponent.scss'

class CountdownComponent extends React.Component {
  constructor(props) {
    super(props)

    const { moment } = this.props
    this.state = {
      notifiedZeroCountdown: moment.isBefore(new Date()),
    }
  }

  componentDidMount() {
    this.onTick()
    this.interval = setInterval(this.onTick.bind(this), 1000)
  }

  componentWillUnmount() {
    clearInterval(this.interval)
  }

  onTick() {
    const { notifiedZeroCountdown } = this.state
    const { moment, onCountdownZero } = this.props
    if (!notifiedZeroCountdown && moment.isSameOrBefore(new Date())) {
      onCountdownZero()
      this.setState({
        notifiedZeroCountdown: true,
      })
    }

    this.forceUpdate()
  }

  getDuration() {
    const { moment } = this.props
    const utcEnd = moment.clone().utc()
    // calculate the duration
    this.duration = momentLib.duration(utcEnd.diff(momentLib.utc()))
    this.durationInSeconds = this.duration.asSeconds()
  }

  renderDate() {
    this.getDuration()
    const {
      prefixRemainingTime,
      prefixMomentFromNowBefore,
      prefixMomentFromNowAfter,
      disableMomentFuturePrefixSuffix,
      moment: momentProp,
    } = this.props

    // Before the last 24 hours
    if (this.durationInSeconds >= 86400) {
      return `${prefixMomentFromNowBefore}${momentProp.fromNow(
        disableMomentFuturePrefixSuffix
      )}`
    }

    // During the last 24 hours
    if (this.durationInSeconds >= 0) {
      const durationAsUTCTime = momentLib.utc(+this.duration)
      return (
        <>
          {prefixRemainingTime}
          <span>{durationAsUTCTime.format('HH:mm:ss')}</span>
        </>
      )
    }

    // After the last 24 hours
    return `${prefixMomentFromNowAfter}${momentProp.fromNow()}`
  }

  render() {
    return <div className="countdown-component">{this.renderDate()}</div>
  }
}

CountdownComponent.propTypes = {
  moment: PropTypes.instanceOf(Object),
  onCountdownZero: PropTypes.func,
  prefixMomentFromNowBefore: PropTypes.string,
  prefixMomentFromNowAfter: PropTypes.string,
  prefixRemainingTime: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  disableMomentFuturePrefixSuffix: PropTypes.bool,
}

CountdownComponent.defaultProps = {
  onCountdownZero: () => {},
  prefixMomentFromNowBefore: '',
  prefixMomentFromNowAfter: '',
  prefixRemainingTime: '',
  disableMomentFuturePrefixSuffix: false,
}

export default CountdownComponent
